import React from 'react';
import { painPoints } from '../data/content';
export function PainPoints() {
  return <section className="bg-navy-800 px-5 py-16 sm:py-20" data-id="element-195" data-mp="2ln2ee50o55nw">
      <div className="mx-auto max-w-4xl" data-id="element-196" data-mp="2lmj1j2pvl7gq">
        <h2 className="mx-auto max-w-2xl text-center font-display text-2xl font-black leading-tight text-white sm:text-3xl" data-id="element-197" data-mp="26yxvp11m8u54">
          Die nächste Einheit steht an – und der Plan fehlt noch?
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-sm leading-relaxed text-white/65 sm:text-base" data-id="element-198" data-mp="1xx85fyjh018x">
          Im Trainingsalltag geht viel Aufmerksamkeit in die Vorbereitung statt
          in die Arbeit mit den Kindern.
        </p>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-199" data-mp="1o1el3szif3gl">
          {painPoints.map(point => <li key={point} className="flex items-start gap-3 rounded-lg border border-signal/30 bg-signal/10 px-4 py-4 text-sm leading-relaxed text-white/85" data-id="element-200" data-mp="1sywwrr4wvwsa">
              <span aria-hidden="true" className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-signal" data-id="element-201" data-mp="3nbwgnwgbrd5d" />
              {point}
            </li>)}
        </ul>
      </div>
    </section>;
}